import { baseErrorHandler } from '@queries/baseErrorHandler';
import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { endPoints } from '../utils/constants/endPoints';
import { queryKeys } from '../utils/constants/queryKeys';

export function useGetIsHaveTelegram() {
  return useQuery<boolean>(
    [queryKeys.ISHAVE_TELEGRAM],
    async () => {
      const res = await $api.get(endPoints.ISHAVE_TELEGRAM);

      return res?.data?.data;
    },
    {
      refetchOnWindowFocus: false,
      retry: false,
      onError: baseErrorHandler
    }
  );
}
